import $ from 'jquery';

export default {
    init() {
        !function(e){"function"==typeof define&&define.amd?define(["jquery"],e):"object"==typeof exports?e(require("jquery")):e(jQuery)}(function(e){var n=/\+/g;function o(e){return t.raw?e:encodeURIComponent(e)}function i(e){return o(t.json?JSON.stringify(e):String(e))}function r(o,i){var r=t.raw?o:function(e){0===e.indexOf('"')&&(e=e.slice(1,-1).replace(/\\"/g,'"').replace(/\\\\/g,"\\"));try{return e=decodeURIComponent(e.replace(n," ")),t.json?JSON.parse(e):e}catch(e){}}(o);return e.isFunction(i)?i(r):r}var t=e.cookie=function(n,c,u){if(void 0!==c&&!e.isFunction(c)){if("number"==typeof(u=e.extend({},t.defaults,u)).expires){var a=u.expires,d=u.expires=new Date;d.setTime(+d+864e5*a)}return document.cookie=[o(n),"=",i(c),u.expires?"; expires="+u.expires.toUTCString():"",u.path?"; path="+u.path:"",u.domain?"; domain="+u.domain:"",u.secure?"; secure":""].join("")}for(var f,p=n?void 0:{},s=document.cookie?document.cookie.split("; "):[],m=0,v=s.length;m<v;m++){var x=s[m].split("="),k=(f=x.shift(),t.raw?f:decodeURIComponent(f)),l=x.join("=");if(n&&n===k){p=r(l,c);break}n||void 0===(l=r(l))||(p[k]=l)}return p};t.defaults={},e.removeCookie=function(n,o){return void 0!==e.cookie(n)&&(e.cookie(n,"",e.extend({},o,{expires:-1})),!e.cookie(n))}});

        jQuery.analytics = function($account, $anonymised){
            if(navigator.userAgent.indexOf("Speed Insights") == -1) {
                (function(i,s,o,g,r,a,m){i['GoogleAnalyticsObject']=r;i[r]=i[r]||function(){
                    (i[r].q=i[r].q||[]).push(arguments)},i[r].l=1*new Date();a=s.createElement(o),
                    m=s.getElementsByTagName(o)[0];a.async=1;a.src=g;m.parentNode.insertBefore(a,m)
                })(window,document,'script','https://www.google-analytics.com/analytics.js','ga');

                ga('create', $account , 'auto');
                ga('send', 'pageview');
                if ($anonymised) {
                    ga('set', 'anonymizeIp', true);
                }
                else {
                    ga('set', 'anonymizeIp', false);
                }
            }
        }


        if($('#cookie-banner').length > 0){
            if(typeof jQuery.cookie === 'undefined'){
                console.warn('Merci d\'installer jQuery cookie via Bower !');
            }else{
                // -- debug
                //sessionStorage.setItem("no-consent", 'false');
                //jQuery.removeCookie('consent');
                // -- debug
                var banner = $('#cookie-banner');
                var gaAccount = banner.attr('data-ga');
                if(jQuery.cookie('consent') === 'true'){
                    banner.remove();
                    jQuery.analytics(gaAccount, false);
                }else{
                    if(sessionStorage.getItem("no-consent") === 'true'){
                        banner.remove();
                    }else{
                        banner.show(0);
                    }
                    jQuery.analytics(gaAccount, true);
                }

                var _jq = jQuery;
                banner.find('#cookieConsent-no').click(function(){
                    banner.hide(0, function(){
                        $(this).remove();
                    });
                    sessionStorage.setItem("no-consent", 'true');
                    _jq.analytics(gaAccount, true);
                });
                banner.find('#cookieConsent-yes').click(function(){
                    banner.hide(0, function(){
                        $(this).remove();
                    });
                    _jq.cookie('consent', 'true', { expires: 365, path: '/' });
                    _jq.analytics(gaAccount, false);
                });
            }
        }
    }
}
